import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { Subject } from 'rxjs';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { StaticViewDataService } from '../../service/static-view-data-service.service';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { LocalstorageService } from '../../service/localstorage.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-all-page-listing',
  templateUrl: './all-page-listing.component.html',
  styleUrls: ['./all-page-listing.component.scss']
})
export class AllPageListingComponent implements OnInit, OnDestroy {

  by_Author;
  getDataUrl = '';
  metaDataUrl = '';
  @ViewChild('listingInput',{static: false}) searchInput: ElementRef;
  socketsAllowed = [];
  filterList = [];
  facets = null;
  pageNum = 0;
  listArray = [];
  listIdArray = [];
  noresults = false;
  private stompClient;
  pageSize = 50;
  pageSizeArray = [50, 100, 150, 200];
  sortByValueOf = null;
  filterUrl = {};
  fields = '';
  initialUrl = '';
  latestUrl = '';
  callFail = false;
  userRestrictedPageTypes: any = [];
  userRestrictedPageList: any = [];
  pages = 0;
  totalRecords = 0;
  str = '';
  searchFocus = false;
  @ViewChildren('listingInput') searchField;
  showMore = false;
  headerList = [];
  routeLinkForList;
  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  @ViewChildren('listData2') listData: ElementRef;
  timings = {
    constr: 0,
    onin: 0,
    resp: 0,
    list: 0,
    getEnv: 0,
    getMeta: 0
  };
  unlockPopup = false;
  lockedUser = '';
  lockedId = null;
  private subject: Subject<string> = new Subject();
  togglePage = null;
  domainConfig = null;
  isSubNavEnabled = false;
  accessType = "";
  user :any;
  currentUrl="";
  excelDataUrl="";
  load = false;
  maxExcelSize = 10000;
  constructor(
    private config: Config,
    private restService: RestDataService,
    private snotify: SnotifyService,
    private sharedService: SharedDataService,
    private router: Router,
    private localstorageService:LocalstorageService
  ) {
    this.timings.constr = performance.now();
    console.log('constructor => 0');
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
  }

  getDomainConfig(currentDomainConfig) {
    this.domainConfig = currentDomainConfig;
    this.isSubNavEnabled = this.domainConfig && this.domainConfig['config']
    && this.domainConfig['config']['pages'] && this.domainConfig['config']['pages']['showSubNav'] === 'true';
    this.maxExcelSize = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['pages']
    && this.domainConfig['config']['pages']['maxExcelSize']) ? +(this.domainConfig['config']['pages']['maxExcelSize']) : 10000;
  }

  ngOnInit() {
    this.timings.onin = performance.now();
    console.log('oninit => ', performance.now() - this.timings.constr);
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.user = this.restService.userDetail;
    if(this.user.domainPermissions[currentDomain].pagePermissions)
    { 
      this.accessType = this.user.domainPermissions[currentDomain].pagePermissions.accessType;
    }
    this.getDataUrl = this.config.get('product').baseUrl + StaticViewDataService.Page_listing_View.urls.listing;
    this.metaDataUrl = this.config.get('product').baseUrl + StaticViewDataService.Page_listing_View.urls.meta;
    this.excelDataUrl = this.config.get('product').baseUrl + StaticViewDataService.Page_listing_View.urls.excel;
    this.socketsAllowed = StaticViewDataService.Page_listing_View.socketCodes;
    const filters = StaticViewDataService.Page_listing_View.filters;
    this.filterList = this.sharedService.getUpdatedFilters(filters);
    this.fields = StaticViewDataService.Page_listing_View.fields;
    this.headerList = StaticViewDataService.Page_listing_View.headers;
    this.routeLinkForList = StaticViewDataService.Page_listing_View.list_router;
    this.getUserPermittedPageTypes();
    this.getUserPermittedPageList();

    this.timings.getEnv = performance.now();
    console.log('getEnv => ', performance.now() - this.timings.onin);


    if (this.searchInput) {
      this.searchInput.nativeElement.focus();
    }

    if (StaticViewDataService.Page_listing_View.sortBy) {
      this.sortByValueOf = StaticViewDataService.Page_listing_View.sortBy;
    }

    if (this.metaDataUrl && this.metaDataUrl.trim() !== '') {
     //page specific url cms-backend-service-mt/api/cms/page/meta
      this.restService.http_get(this.metaDataUrl)
        .subscribe(data => {
          this.facets = { ...data, ...this.facets };
          this.facets['toBeAutobacklink'] = {true:0, false:0}
        });
      // let metaData=this.localstorageService.getMetaData();
      // console.log('all-page-listing.componet metadata',metaData);
      // this.facets=metaData;  
    }
    this.timings.getMeta = performance.now();
    console.log('getmeta => ', performance.now() - this.timings.getEnv);

    this.getDefaultList(0, this.dataInsertion);

    this.subject
      .pipe(debounceTime(800),
      distinctUntilChanged())
      .subscribe(result => {
        this.searchResults(result, 0, this.dataInsertion);
      });
      if(this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['socket'] && this.domainConfig['config']['socket']['enableSocket'] && this.domainConfig['config']['socket']['enableSocket'] === 'true')
      {
        this.initializeWebSocketConnection();
      }
  }

  getUserPermittedPageTypes() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const restrictedPagesObj = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].page
    
    if(restrictedPagesObj && restrictedPagesObj.length > 0) {
      for(let item of restrictedPagesObj) {
        if(item) {
          this.userRestrictedPageTypes.push(item.name)
        }
      }
    }
  }

  getUserPermittedPageList() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const restrictedPagesListObj = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].pageList
    
    if(restrictedPagesListObj && restrictedPagesListObj.length > 0) {
      for(let item of restrictedPagesListObj) {
        if(item) {
          this.userRestrictedPageList.push(item.alias)
        }
      }
    }
  }


  initializeWebSocketConnection() {
    const ws = new SockJS(this.config.get('product').socketUrl
      + '?access_token='
      + JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).access_token);
    this.stompClient = Stomp.over(ws);
    this.stompClient.debug = false;
    const self = this;
    const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.stompClient.connect({}, function (frame) {
      if (self.socketsAllowed.indexOf(5) > -1) {
        self.stompClient.subscribe('/topic/zone-lock-' + domain, (message) => {
          const tempObj = JSON.parse(message.body);
          const j = self.listIdArray.indexOf(tempObj.zoneId);
          if (j > -1 && self.listArray[j].id === tempObj.zoneId && (self.initialUrl === self.latestUrl)) {
            self.listArray[j].lockedByUserId = tempObj.lockedByUserId;
            self.listArray[j].lockedByUserName = tempObj.lockedByUserName;
          }
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }

      if (self.socketsAllowed.indexOf(6) > -1) {
        self.stompClient.subscribe('/topic/page-update-' + domain, (message) => {
          const bodyObj = JSON.parse(message.body);
          const j = self.listIdArray.indexOf(bodyObj.zoneId);
          if ((j > -1) && (self.listArray[j].id === bodyObj.zoneId) && (self.initialUrl === self.latestUrl)) {
            self.listArray[j] = bodyObj;
          }
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }
    },
      err => {
        console.log(err);
      });
  }

  searchResults(query, pageNum, callback) {
    if (query && query.trim() !== '') {
      let url = this.getDataUrl + '?page=' + pageNum + '&size=' + this.pageSize;
      if (this.sortByValueOf) {
        url += '&sort=' + this.sortByValueOf + ',desc';
      }
      url += this.fields;
      url += '&search=';
      if(this.userRestrictedPageTypes && this.userRestrictedPageTypes.length > 0) {
        url += ',pageType:'
        for(let sec of this.userRestrictedPageTypes) {
          url += sec + (this.userRestrictedPageTypes.length > 1 ? ';' : '');
        }
     }
     if(this.userRestrictedPageList && this.userRestrictedPageList.length > 0) {
      url += ',alias@'
      for(let sec of this.userRestrictedPageList) {
        url += sec + (this.userRestrictedPageList.length > 1 ? ';' : '');
      }
   }
      if (this.filterUrl) {
        for (const filter in this.filterUrl) {
          if (filter) {
            url += this.filterUrl[filter];
          }
        }
      }
      const querArr = query.split(':');
      if (querArr && querArr.length > 1 && querArr[0].toUpperCase() === 'ID') {
        url += ',id:' + querArr[1].trim();
      }
      else if (querArr && querArr.length > 1 && querArr[0].toUpperCase() === 'URL') {
        url += ',url:' + querArr[1].trim();
      }
       else {
        url += ',name~' + StaticDataService.encodeSpecialChar(query);
      }
      // if (url.indexOf('EXTERNAL') === -1) {
      //   url += ',pageType!EXTERNAL';
      // }
      this.callFail = false;
      this.latestUrl = url;
      this.timings['firstGet'] = performance.now();
      console.log('firstGet => ', performance.now() - this.timings.getMeta);
      this.currentUrl = cloneDeep(url);
      this.restService.http_get(url)
        .subscribe(data => {
          this.timings.resp = performance.now();
          console.log('response received => ', performance.now() - this.timings['firstGet']);
          this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
          this.totalRecords = data['totalElements'];
          this.topFunction();
          this.callFail = false;
          this.measureTime(0);
          callback(data);
        },
          error => {
            this.callFail = true;
            // console.log(error);
          });
    } else {
      this.getDefaultList(pageNum, data => {
        callback(data);
      });
    }
  }

  getDefaultList(pageNum, callback) {
    let url = this.getDataUrl + '?page=' + pageNum + '&size=' + this.pageSize;
    if (this.sortByValueOf) {
      url += '&sort=' + this.sortByValueOf + ',desc';
    }
    url += this.fields;
    url += '&search=';

    if(this.userRestrictedPageTypes && this.userRestrictedPageTypes.length > 0) {
      url += ',pageType:'
      for(let sec of this.userRestrictedPageTypes) {
        url += sec + (this.userRestrictedPageTypes.length > 1 ? ';' : '');
      }
   }
   if(this.userRestrictedPageList && this.userRestrictedPageList.length > 0) {
    url += ',alias@'
    for(let sec of this.userRestrictedPageList) {
      url += sec + (this.userRestrictedPageList.length > 1 ? ';' : '');
    }
 }
    if (this.filterUrl) {
      console.log(this.filterUrl)
      for (const filter in this.filterUrl) {
        if (filter) {
          url += this.filterUrl[filter];
        }
      }
    }
    // if (url.indexOf('EXTERNAL') === -1) {
    //   url += ',pageType!EXTERNAL';
    // }
    this.callFail = false;
    if (this.initialUrl === '') {
      this.initialUrl = url;
    }
    this.latestUrl = url;
    this.timings['firstGet'] = performance.now();
    console.log('firstGet => ', performance.now() - this.timings.getMeta);
    this.currentUrl = cloneDeep(url);
    this.restService.http_get(url)
      .subscribe(data => {
        this.timings.resp = performance.now();
        console.log('response received => ', performance.now() - this.timings['firstGet']);
        this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
        this.totalRecords = data['totalElements'];
        this.callFail = false;
        this.topFunction();
        this.measureTime(0);
        callback(data);
      });
  }

  dataInsertion = (data) => {
    const results = data['content'];
    this.listArray = [];
    this.listIdArray = [];
    if (results && results.length > 0) {
      this.listArray = results;
      this.listIdArray = results.map(e => e.id);
      this.noresults = false;
    } else {
      this.noresults = true;
    }
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    if (document.getElementsByClassName('contentList') && document.getElementsByClassName('contentList').length > 0) {
      document.getElementsByClassName('contentList')[0].scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }

  arrayOne(n: number) {
    return Array(n);
  }

  onPageNumberChange(pagenum) {
    this.pageNum = pagenum;
    this.searchResults(this.str, this.pageNum, this.dataInsertion);
  }

  onPageSizeChange(size) {
    this.pageNum = 0;
    this.pageSize = size;
    this.searchResults(this.str, this.pageNum, this.dataInsertion);
  }

  onKeydown(event, input) {
    this.subject.next(input.value);
  }

  getFilterData(facet_name) {
    if (this.facets && this.facets[facet_name]) {
      return this.facets[facet_name];
    } else {
      return null;
    }
  }

  urlUpdate(ev) {
    this.filterUrl[ev.type] = ev.data;
    this.pageNum = 0;
    this.searchResults(this.str, this.pageNum, this.dataInsertion);
  }

  checkFocusInside(elem) {
    return (elem && elem.contains(document.activeElement));
  }


  getFullDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear() + ', ' +
        ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
    } else {
      return 'not present';
    }
  }

  getNewTypeDate(datestring) {
    if (datestring) {
      if (typeof datestring === 'string') {
        const dt = new Date(datestring.replace('+0000', 'Z'));
        return this.getFullDate(Math.round(dt.getTime()));
      } else {
        return this.getFullDate(datestring);
      }
    } else {
      return 'not present';
    }
  }

  getDateWithoutTime(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return '' + this.monthNames[date.getMonth()]+ ' ' + date.getDate() + ', ' + ' ' + date.getFullYear();
    } else {
      return 'not present';
    }
  }

  getDate(datestring) {
    if (datestring) {
      if (typeof datestring === 'string') {
        const dt = new Date(datestring.replace('+0000', 'Z'));
        return this.getDateWithoutTime(Math.round(dt.getTime()));
      } else {
        return this.getDateWithoutTime(datestring);
      }
    } else {
      return '';
    }
  }

  getclassonCondition(lockStatus, storyStatus) {
    let ulClass = null;
    if (lockStatus && storyStatus === 'PUBLISHED') {
      ulClass = 'publishlockedIcon';
    } else if (lockStatus) {
      ulClass = 'lockedIcon icon-lock';
    } else if (storyStatus === 'PUBLISHED') {
      ulClass = 'publishIcon icon-published';
    }
    return ulClass;
  }


  measureTime(count) {
    if (this.listData && this.listData['length'] === this.pageSize) {
      this.timings.list = performance.now();
      console.log('list loaded => ', performance.now() - this.timings.resp);
      console.log('total first load time => ', performance.now() - this.timings.constr);
    } else if (count < 6) {
      setTimeout(e => {
        this.measureTime(++count);
      }, 0);
    }
  }

  openOptions(index) {
    if (this.listArray[index].lockedByUserId) {
      this.openUnlock(index);
    }
  }

  openUnlock(index) {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = localStorage.getItem(StaticDataService.tokenLiteral) ?
      JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role
      : null;
    if (role && (role !== 'ROLE_ADMIN' && role !== 'ROLE_SUPER_ADMIN' && role !== 'ROLE_EDITOR' && role!=='ROLE_SITE_MANAGER')) {
      this.snotify.warning('You don’t have permission to unlock', '', this.sharedService.getConfig(false));
    } else {
      this.unlockPopup = true;
      this.sharedService.overflowhidden();
      this.lockedUser = this.listArray[index].lockedByUserName;
      this.lockedId = this.listArray[index].id;
    }
  }

  cancelUnlock() {
    this.unlockPopup = false;
    this.lockedUser = '';
    this.lockedId = null;
    this.sharedService.overflowauto();
  }

  unlockStory() {
    this.unlockPopup = false;
    this.sharedService.overflowauto();
    this.restService.http_get(
      this.config.get('product').baseUrl
      + StaticViewDataService.Page_listing_View.urls.unlock
      + '?pageId='
      + String(this.lockedId)
    )
      .subscribe(
        data => {
          this.lockedUser = '';
          this.lockedId = null;
          this.snotify.success('Page Unlocked', '', this.sharedService.getConfig(false));
        },
        error => {
          // console.log('Couldn\'t unlock story');
        });

    this.sharedService.overflowauto();
  }

  showNav(pageId) {
    if (this.togglePage === pageId) {
      this.togglePage = null;
    } else {
      this.togglePage = pageId;
    }
  }

  ngOnDestroy() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect();
    }
  }

  generateCSV()
  {
    if(this.currentUrl != null)
    {
      if(this.maxExcelSize < this.totalRecords)
      {
        this.snotify.error('Number of records are greater than ' + this.maxExcelSize + ',Please filter more', '', this.sharedService.getConfig(false));
      }else{
        let reportURl = this.currentUrl.replace(this.getDataUrl, this.excelDataUrl);
        const options = { responseType: 'blob' };
        this.load = true;
        this.snotify.info('Downloading excel', '', this.sharedService.getConfig(false));
        this.restService.http_get_options(reportURl, options).subscribe((res: any) => {
          saveAs(res, "abc.xlsx");
          this.load = false;
          this.snotify.info('Excel downloaded', '', this.sharedService.getConfig(false));
        }, (err) => {
          this.load = false;
          this.snotify.error('Failed to download excel', '', this.sharedService.getConfig(false));
        });
      }
    }
    
  }
}
